// eslint-disable-next-line no-restricted-imports
import { Trans } from '@lingui/macro'
import { REFERRALS_SUBGRAPH_URL } from 'constants/subgraph'
import request, { gql } from 'graphql-request'
import useActiveWeb3React from 'hooks/useActiveWeb3React'
import React, { useEffect, useState } from 'react'
import styled from 'styled-components/macro'
import { ThemedText } from 'theme'
import { shortenAddress } from 'utils'
import { isChainAllowed } from 'utils/switchChain'
import { isMobile } from 'utils/userAgent'

const DataContentWrapper = styled.main`
  background-color: ${({ theme }) => theme.bg0};
  border-radius: 8px;
  border: 1px solid #8247e5;
  padding: 16px;
  margin-top: 2rem;
`
const ResponsiveGrid = styled.div<{ isMobile?: boolean }>`
  display: grid;
  align-items: center;
  justify-content: center;
  grid-template-columns: ${({ isMobile }) => (isMobile ? '0.6fr 0.6fr' : '1fr 1fr')};
  }
`
const TableWrapper = styled.div`
  flex-direction: column;
`
const MyDataInfo = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-around;
  padding: 16px;
`

interface ReferralRow {
  id: string
  points: number
}

function ReferralsList() {
  const { account, chainId, connector } = useActiveWeb3React()
  const chainAllowed = chainId && isChainAllowed(connector, chainId)
  const [userReferrals, setUserReferrals] = useState<ReferralRow[]>([])

  const apiUrl = REFERRALS_SUBGRAPH_URL[chainAllowed ? chainId : 137]

  useEffect(() => {
    if (account) {
      request(
        apiUrl,
        gql`
          query GetUserRefferals($address: String!) {
            referrers(where: { address: $address }) {
              referrals {
                id
                points
              }
            }
          }
        `,
        {
          address: account?.toLowerCase(),
        }
      ).then(({ referrers }) => {
        if (referrers.length > 0) {
          setUserReferrals(referrers[0].referrals)
        }
      })
    }
  }, [account, apiUrl])

  return (
    <DataContentWrapper>
      {userReferrals && userReferrals.length > 0 ? (
        <TableWrapper>
          <ResponsiveGrid isMobile={isMobile}>
            <ThemedText.Body fontSize={isMobile ? '12px' : '18px'} textAlign="center">
              <Trans>Referral</Trans>
            </ThemedText.Body>
            <ThemedText.Body fontSize={isMobile ? '12px' : '18px'} textAlign="center">
              <Trans>Points</Trans>
            </ThemedText.Body>
          </ResponsiveGrid>
          {userReferrals.map((item, key) => (
            <ResponsiveGrid isMobile={isMobile} key={key}>
              <ThemedText.Body fontSize={isMobile ? '12px' : '18px'} textAlign="center">
                {shortenAddress(item.id)}
              </ThemedText.Body>
              <ThemedText.Body fontSize={isMobile ? '12px' : '18px'} textAlign="center">
                {item.points}
              </ThemedText.Body>
            </ResponsiveGrid>
          ))}
        </TableWrapper>
      ) : (
        <MyDataInfo>
          <ThemedText.Body fontSize={isMobile ? '12px' : '18px'} alignItems="center">
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <Trans>You not have referrals</Trans>!
            </div>
          </ThemedText.Body>
        </MyDataInfo>
      )}
    </DataContentWrapper>
  )
}

export default ReferralsList
